<footer>
    <div class="container">
        <div class="row justify-content-between bgCustom" style="width: 100%; margin-right: auto;">
            <div class="col-sm-3">
                <div class="visitor_count d-inline-block fs-14 fw-400">
                    <span>
                        <img src="/assets/images/totalVisitor-Icon.svg" width="20" class="img-fluid me-1" alt="">
                    </span>
                    Total Visitors : <span class="fw-600">{{ totalVisitor }}</span>
                </div>
                <div class="fs-14 fw-400 mb-2 text-white">Connect with us on social media</div>
                <div class="d-flex">
                    <a href="https://www.facebook.com/IndiaRuralDev" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/facebookIcon-shg.svg" class="img-fluid me-2" alt=""></a>
                    
                    <a href="https://twitter.com/mord_goi" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/twitterIcon-shg.svg" class="img-fluid me-2" alt=""></a>

                    <a href="https://www.youtube.com/channel/UCgZxfCRDCfMjuxe9N61210g?view_as=subscriber" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/youtubeIcon-shg.svg" class="img-fluid me-2" alt=""></a>

                    <a href="https://www.instagram.com/indiaruraldev/" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/instagramIcon-shg.svg" class="img-fluid me-2" alt=""></a>

                </div>
            </div>
            <div class="col-sm-3 footer_address">
                <div class="fs-14 fw-400">Contact Us</div>
                <div class="fs-12" class="mt-2">Deendayal Antyodaya Yojana -&nbsp;</div>
                <div class="fs-12">National Rural Livelihoods Mission (DAY-NRLM)</div>
                <div class="fs-12">Ministry of Rural Development - Govt. of India</div>
                <div class="fs-12">7th Floor, NDCC Building -II, Jai Singh Road</div>
                <div class="fs-12">New Delhi - 110001</div>
                <div class="fs-12">Phone: 011 - 23461708</div>
            </div>
        </div>
    </div>
</footer>
<div class="back-to-top" (click)="scrollToTop()">
    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/><path d="M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20 M12,22c5.52,0,10-4.48,10-10c0-5.52-4.48-10-10-10 C6.48,2,2,6.48,2,12C2,17.52,6.48,22,12,22L12,22z M11,12l0,4h2l0-4h3l-4-4l-4,4H11z"/></g></svg>
</div>
